var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9004699_cross_delete_remove_cancel_close_icon",
    "data-name": "9004699_cross_delete_remove_cancel_close_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_220032",
    "data-name": "Path 220032",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.333A8.333,8.333,0,1,1,18.333,10,8.333,8.333,0,0,1,10,18.333Z",
    fill: "#cc4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220033",
    "data-name": "Path 220033",
    d: "M15.089,7.244a.833.833,0,0,0-1.178,0L11.167,9.988,8.423,7.244A.833.833,0,1,0,7.244,8.423l2.744,2.744L7.244,13.911a.833.833,0,1,0,1.178,1.178l2.744-2.744,2.744,2.744a.833.833,0,1,0,1.178-1.178l-2.744-2.744,2.744-2.744a.833.833,0,0,0,0-1.178Z",
    transform: "translate(-1.167 -1.167)",
    fill: "#cc4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/Failure.b4d32d23e61b0c1b7fca4d8d78a45be3.svg";
export { ForwardRef as ReactComponent };